import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
`;

const Content = styled.div`
  text-align: center;
  color: white;
  max-width: 600px;
`;

const Title = styled.h1`
  font-size: clamp(32px, 8vw, 64px);
  margin-bottom: 20px;
  font-weight: 700;
  letter-spacing: -1px;
  animation: fadeInDown 0.8s ease-out;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.95;
  line-height: 1.6;
  animation: fadeInUp 0.8s ease-out 0.2s both;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Loading = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 40px 0;
  animation: fadeIn 0.8s ease-out 0.4s both;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const Dot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
  animation: bounce 1.4s infinite;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: translateY(0);
      opacity: 1;
    }
    40% {
      transform: translateY(-20px);
      opacity: 0.7;
    }
  }
`;

const Footer = styled.p`
  margin-top: 50px;
  font-size: 14px;
  opacity: 0.8;
  animation: fadeIn 0.8s ease-out 0.6s both;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 0.8;
    }
  }
`;

const MaintenanceMode: React.FC = () => {
  return (
    <Container>
      <Content>
        <Title>🚀 Portfolio Update in Progress</Title>
        <Subtitle>
          I'm working on some exciting improvements! The portfolio will be back
          online very soon with fresh features and enhancements.
        </Subtitle>
        <Loading>
          <Dot />
          <Dot />
          <Dot />
        </Loading>
        <Footer>
          Thank you for your patience. Check back in a few moments!
        </Footer>
      </Content>
    </Container>
  );
};

export default MaintenanceMode;
